import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import { WHITE } from 'bento-ordering/base/constants/colors';

const useStyles = makeStyles(theme => ({
  root: {
    color: WHITE,
    fontSize: 36,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }
  }
}));
const HeroHeading = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h1" classes={classes} align="center">
      {children}
    </Typography>
  );
};

HeroHeading.propTypes = {
  children: PropTypes.string
};

export default HeroHeading;
